<div class="modal-header align-items-center">
  <div class="col">
    <h4 class="modal-title" translate>Last submitted row</h4>
  </div>
  <div class="col-auto">
    <button (click)="onClose()" aria-label="Close" class="close" type="button">
      <span aria-hidden="true" class="fa-solid fa-xmark"></span>
    </button>
  </div>
</div>

<div class="modal-body">

  @if (!mapHasValues) {
    <div class="alert alert-info text-center">
      <span translate>Currently there is no submitted row yet.</span>
    </div>
  }

  @if (mapHasValues) {
    <table class="table mb-0">
      <thead>
        <tr>
          <th>
            <span translate>Column</span>
          </th>
          <th>
            <span translate>Value</span>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (row of lastRow | keyvalue; track row) {
          <tr>
            <td>
              <span [innerHTML]="row.key"></span>
            </td>
            <td>
              @if (row.key === 'timestamp') {
                <span
                [innerHTML]="inMilliseconds(row.value) | date:'yyyy-MM-dd HH:mm:ss z'"></span>
              }
              @if (row.key !== 'timestamp') {
                <span [innerHTML]="row.value | json"></span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>

<scitis-modal-footer (cancelButtonPressed)="onClose()"
  (okButtonPressed)="onDeleteThisRow()"
  [cancelButtonText]="'Cancel'|translate"
  [disableOkButton]="!mapHasValues"
  [okButtonText]="'Delete this row'|translate">
</scitis-modal-footer>